<ng-container *ngIf="hideOrShow()">
  <div class="go-back" (click)="onGoBack()">
    <img class="desktop" src="/assets/icons/blue-return-icon.svg" alt="Volver en azul" />
    <img class="mobile" src="/assets/icons/white-return-icon.svg" alt="Volver en blanco" />
    <p>Volver</p>
  </div>
</ng-container>
